export default __webpack_public_path__ + "media/images/activite-59248d2fa938536e3b84b1b95d55cba1.PNG";